import Big from 'big.js';
import { formatNumber } from './format';

export const getDiv: (a: number, b: number) => number = (a, b) => Number(Big(a).div(Big(b)));

export const getTimes: (a: number, b: number) => number = (a, b) => Number(Big(a).times(Big(b)));

export const getPlus: (a: number, b:number) => number = (a, b) => Number(Big(a).plus(Big(b)));

export const getPercentStr: (val: number, total: number) => string = (val, total) => {
  const div = getDiv(val, total);
  const num = formatNumber(div, 2);
  return `${getTimes(num, 100)}%`;
};
